import React, { useState } from "react";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import ActiveEklokContainer from "../../containers/ekloks/ActiveEklokContainer";
import ActiveEklokForm from "../../forms/eklok/ActiveEklokForm";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Activation = ({ handleClose, open, eklok }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  const [activationCode, setActivationCode] = useState(null);

  return (
    <Modal
      fullScreen={matches}
      fullWidth={true}
      maxWidth="xs"
      open={open}
      onClose={handleClose}
      title={t("active_eklok.generate_code")}
    >
      {eklok ? (
        <ActiveEklokContainer setResult={setActivationCode}>
          {({ onSubmit }) => (
            <ActiveEklokForm
              onSubmit={onSubmit}
              initialValues={{ eklok: eklok.id }}
              activationCode={activationCode}
            />
          )}
        </ActiveEklokContainer>
      ) : null}
    </Modal>
  );
};

export default Activation;
